/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
window.scrollToBody = {
  initialize() {
    $('.scroll-mock').remove();
    this.tableScrollBarWidth = window.getScrollBarWidth();

    this.tableSticky = $('.with-scroll:visible');
    if (this.tableSticky.length > 0) {
      this.tableStickyEl = this.tableSticky.get(0);
      this.scrollSection = this.tableSticky.closest('.scroll-to-body');
      this.maxLeft = (this.tableSticky.width() - this.scrollSection.width()) + this.tableScrollBarWidth;
      return this._initializeScrollToBody();
    } else {
      return this._destroyScroll();
    }
  },


  _initializeScrollToBody() {
    this.tableScrollBarWidth = 0;
    let mockScrollWidth = $('body').width() + (this.tableSticky.width() - this.scrollSection.width()) + window.getScrollBarWidth();
    if ($('.scroll-mock').length === 0) { $('body').prepend(`<div class='scroll-mock' style='width: ${mockScrollWidth}px'></div>`); }
    $(window).bind("scroll", _.bind(this._copyScrollPosition, this));
    return $(window).bind("resize", () => {
      mockScrollWidth = $('body').width() + (this.tableSticky.width() - this.scrollSection.width()) + this.tableScrollBarWidth;
      return $('.scroll-mock').css({width: `${mockScrollWidth}px`});
    });
  },

  _destroyScroll() {
    if (($('.table-scroll').length > 0) && ($('.with-sticky').length > 0)) {
      if ($('.scroll-mock').length > 0) {
        $('.scroll-mock').remove();
        $(window).unbind("scroll");
      } else {
        $('.table-scroll').unbind("scroll");
      }
      return $(window).unbind("resize");
    }
  },

  _copyScrollPosition() {
    const left = $(window).scrollLeft();
    return this.scrollSection.scrollLeft(left);
  }

};

$(document).on('toggleSidebar', () => window.scrollToBody.initialize());
